export const paths = [{ "tag": "path", "att": { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M13.0009 2.586 4 11.5868v5.4144h5.4142l8.9944-8.9944-5.4077-5.421zM6 15.0012v-2.5859l6.9991-6.9993 2.5828 2.589-6.9961 6.9962H6z" } }, { "tag": "path", "att": { "d": "M4 21.0009h16v-2H4v2z" } }];
export const iconName = 'pencil';
export const pencil = { iconName, paths };
export default paths;
